import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { interval, of } from 'rxjs';
import { map, mergeMap, throttle, withLatestFrom } from 'rxjs/operators';
import { AccountService } from '../../services/account.service';
import { UserManagementService } from '../../services/user-management.service';
import { RequestUtil } from '../../utils/request.util';
import { ActionTypes, LoadAccount, LoadProfile, LoadSuccessManager } from '../actions/my-account.action';
import { MyAccountState } from '../state/my-account.state';

@Injectable()
export class MyAccountEffects {
    fetchProfile$ = createEffect(() =>
        this.action$
            .pipe(
                ofType<LoadProfile>(ActionTypes.LoadProfile),
                withLatestFrom(this.store.select(state => state.profile)),
                mergeMap(([action, state]) => {
                    if (Object.keys(state).length === 0 || action.payload && action.payload.reload) {
                        return this.requestUtil.request(this.userManagementService.getUserProfile().pipe(
                            map(profile => ({type: ActionTypes.LoadProfileComplete, payload: profile})
                            )));
                    }
                    return of(state).pipe(
                        map(profile => ({type: ActionTypes.LoadProfileComplete, payload: profile})
                        ));
                })
            )
    );

    fetchSuccessManager$ = createEffect(() =>
        this.action$
            .pipe(
                ofType<LoadSuccessManager>(ActionTypes.LoadSuccessManager),
                throttle(() => interval(1)),
                withLatestFrom(this.store.select(state => state.successManager)),
                mergeMap(([, state]) => {
                    if (Object.keys(state).length === 0) {
                        return this.requestUtil.request(this.accountService.getSuccessManager().pipe(
                            map(res => {
                                if (res.status === 204) {
                                    return ({type: ActionTypes.LoadSuccessManagerComplete, payload: {error: true, result: null}});
                                } else {
                                    return ({type: ActionTypes.LoadSuccessManagerComplete, payload: {error: false, result: res.body}});
                                }
                            })
                        ));
                    }
                    return of(state).pipe(
                        map(res => ({type: ActionTypes.LoadSuccessManagerComplete, payload: res})
                        ));
                })
            )
    );

    fetchAccount$ = createEffect(() =>
        this.action$
            .pipe(
                ofType<LoadAccount>(ActionTypes.LoadAccount),
                throttle(() => interval(1)),
                withLatestFrom(this.store.select(state => state.account)),
                mergeMap(([, state]) => {
                    if (Object.keys(state).length === 0) {
                        return this.requestUtil.request(this.accountService.getAccountInformation().pipe(
                            map(accountInformation => ({type: ActionTypes.LoadAccountComplete, payload: accountInformation})
                            )));
                    }
                    return of(state).pipe(
                        map(accountInformation => ({type: ActionTypes.LoadAccountComplete, payload: accountInformation})
                        ));
                })
            )
    );
    constructor(
        private action$: Actions,
        private store: Store<MyAccountState>,
        private accountService: AccountService,
        private userManagementService: UserManagementService,
        private requestUtil: RequestUtil
    ) {}

}

